import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import LanguageSwitcher from "../../../components/LanguageSwitcher";
import LandingFooter from "../../../components/layout/LandingFooter";
import LandingMenu from "../../../components/layout/LandingMenu";
import LoginButton from "../../../components/layout/LoginButton";

import IsPropertyFound from "./components/IsPropertyFound";
import SelectRegion from "./components/SelectRegion";

import logoImg from "../../../assets/logo2.png";
import "./SelectService.css";

const VALID_REGIONS = new Set(["flanders", "girona"]);

function normaliseRegion(value) {
  const region = String(value || "")
    .trim()
    .toLowerCase();

  return VALID_REGIONS.has(region)
    ? region
    : "";
}

export default function SelectService() {
  const navigate = useNavigate();
  const location = useLocation();

  const routeRegion = normaliseRegion(
    location.state?.region,
  );

  const routeStep =
    location.state?.step === 2 &&
    routeRegion
      ? 2
      : 1;

  const [step, setStep] =
    React.useState(routeStep);

  const [region, setRegion] =
    React.useState(routeRegion);

  React.useEffect(() => {
    const nextRegion = normaliseRegion(
      location.state?.region,
    );

    const nextStep =
      location.state?.step === 2 &&
      nextRegion
        ? 2
        : 1;

    setRegion(nextRegion);
    setStep(nextStep);
  }, [location.state]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [step]);

  const handleRegionContinue = (
    selectedRegion,
  ) => {
    const nextRegion = normaliseRegion(
      selectedRegion,
    );

    if (!nextRegion) {
      return;
    }

    setRegion(nextRegion);
    setStep(2);

    navigate("/services", {
      state: {
        step: 2,
        region: nextRegion,
      },
    });
  };

  const handleBackToRegions = () => {
    setStep(1);
    setRegion("");

    navigate("/services", {
      replace: true,
      state: {
        step: 1,
      },
    });
  };

  const handlePropertyAction = (
    action,
  ) => {
    if (!region) {
      handleBackToRegions();
      return;
    }

    if (action === "simulate") {
      navigate(
        `/simulations?region=${encodeURIComponent(region)}`,
      );

      return;
    }

    if (action === "register") {
      navigate("/register/homebuyer");
    }
  };

  return (
    <div>
      <div className="select-service-page">
        <div className="select-service-topbar">
          <LandingMenu />

          <Link
            to="/"
            className="select-service-logo"
            aria-label="LEG-UP home"
          >
            <img
              src={logoImg}
              alt="LEG-UP"
            />
          </Link>

          <div className="select-service-topbar__right">
            <LanguageSwitcher />
            <LoginButton />
          </div>
        </div>

        <main>
          {step === 1 && (
            <SelectRegion
              onContinue={
                handleRegionContinue
              }
            />
          )}

          {step === 2 && (
            <IsPropertyFound
              onContinue={
                handlePropertyAction
              }
              onBack={
                handleBackToRegions
              }
            />
          )}
        </main>
      </div>

      <LandingFooter />
    </div>
  );
}
